module.exports = __webpack_public_path__ + "img/l_ball.5e453a12.jpg";